import type { ApproverDto } from "common/models/api/models/ApproverDto";
import type { UpdateApproverDto } from "common/models/api/models/UpdateApproverDto";
import { useMutation, UseMutationResult } from "react-query";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { releaseStrategyApi } from "../api/releaseStrategyApi";

export interface UseUpdateApproverProps {
    id: number;
    body: UpdateApproverDto;
}

export default function useUpdateApprover(
    options?: UseCustomMutationOptions<ApproverDto, unknown, UseUpdateApproverProps>,
): UseMutationResult<ApproverDto, unknown, UseUpdateApproverProps> {
    return useMutation(async ({ id, body }: UseUpdateApproverProps) => {
        const res = await releaseStrategyApi.updateApprover(id, body);
        return res.data;
    }, options);
}
